import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { selectBusinessTeamsById } from 'state/ProjectsList/include/businessTeamsSlice';

interface ProjectBusinessUnitsProps {
  teams: string[];
}
const ProjectBusinessUnits: FC<ProjectBusinessUnitsProps> = ({ teams }) => {
  const businessTeams = useSelector((state: RootState) =>
    selectBusinessTeamsById(state, teams)
  );

  if (businessTeams.length === 0) {
    return null;
  }

  const teamNames = businessTeams.map((team) => team.name).join(', ');

  return <>{teamNames}</>;
};

export default ProjectBusinessUnits;
